import React, { useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import Select from 'react-select'
import { ClientService } from '../../component/services/client.service';
import StatsCard from '../../component/Cards/StatsCard';
import StatsCardWithProgress from '../../component/Cards/StatsCardWithProgress';
import DonutChart, { ChartDataItem } from '../../component/Charts/DonutChart';
import CetLoader from '../../component/Loader/CetLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faCheckCircle,
    faTimesCircle,
    faUniversity,
    faUserCheck,
    faUserTie,
    faPlay,
    faClipboardCheck
} from '@fortawesome/free-solid-svg-icons';
import ReverificationTable from '../../component/table/Reverification.table';
import TablePaginationComponent from '../../component/table/TablePagination';
import ReverificationUsersModal from '../../component/modals/ReverificationUsers.modal';

export default function CollegeOverview() {
    const [colleges, setColleges] = useState<any[]>([]);
    const [selectedCollege, setSelectedCollege] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [collegeStats, setCollegeStats] = useState<any>(null);
    const [chartData, setChartData] = useState<ChartDataItem[]>([]);

    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [streams, setStreams] = useState<any>();
    const [selectedStreams, setSelectedStreams] = useState<any>();
    const [reverificationUsers, setReverificationsUsers] = useState<any>();
    const [showReverificationModal, setShowReverificationModal] = useState<any>(undefined);

    const getAllUsersReverifications = async () => {
        await ClientService.getAllUsersReverifications(pageNumber, pageSize, selectedCollege, streams).then((res) => {
            if (res.status === 200) {
                setReverificationsUsers(res.data.data?.reverifications);
                setTotal(res.data.data?.count);
            }
        }).catch((er) => {
            console.log(er)
        })
    }

    async function fetchColleges() {
        setLoading(true);
        await ClientService.getReverificationColleges()
            .then((res: any) => {
                if (res.status === 200) {
                    const collegeOptions = res.data?.data?.map((college: any) => ({
                        value: college?.collegId,
                        label: college?.collegeName
                    })) || [];
                    setColleges(collegeOptions);
                } else {
                    console.error("Failed to fetch colleges:", res);
                }
            })
            .catch((error: any) => {
                console.error("Error fetching colleges:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    async function getCollegeStats() {
        setLoading(true);
        await ClientService.getReverificationCollegeStats(selectedCollege)
            .then((res: any) => {
                if (res.status === 200) {
                    const statsData = res.data?.data || null;
                    setCollegeStats(statsData);

                    // Prepare chart data for verified/not verified visualization
                    if (statsData) {
                        const verifiedStudents = statsData.uniqueVerifications || 0;
                        const totalStudents = statsData.totalStudentsCount || 0;
                        const notVerifiedStudents = totalStudents - verifiedStudents;

                        const newChartData: ChartDataItem[] = [
                            {
                                category: "Verified",
                                value: verifiedStudents,
                                fill: "#28a745"
                            },
                            {
                                category: "Not Verified",
                                value: notVerifiedStudents,
                                fill: "#6c757d"
                            }
                        ];
                        setChartData(newChartData);
                    }
                } else {
                    console.error("Failed to fetch college stats:", res);
                }
            })
            .catch((error: any) => {
                console.error("Error fetching college stats:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        if (selectedCollege) {
            getCollegeStats();
        }
    }, [selectedCollege]);

    useEffect(() => {
        if (selectedCollege) {
            getAllUsersReverifications();
        }
    }, [selectedCollege, pageNumber, pageSize])


    useEffect(() => {
        fetchColleges();
    }, []);
    return (
        <>



            {loading ? (
                <div className="mt-4">
                    <CetLoader />
                </div>
            ) : (
                <>
                    <Card className="mt-4 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                        <Card.Body className="px-4">
                            <div className='d-flex justify-content-between align-items-center'>
                                <div>
                                    <h5 className="text-secondary fw-bold mb-3" style={{ fontSize: '18px' }}>
                                        College Overview
                                    </h5>
                                </div>
                                <div>
                                    <Select
                                        options={colleges}
                                        placeholder="Select College"
                                        onChange={(e: any) => setSelectedCollege(e?.value)}
                                        isClearable
                                        value={
                                            colleges.find((college: any) => college.value === selectedCollege) || null
                                        }
                                    />
                                </div>
                            </div>
                            {selectedCollege && collegeStats ? (
                                <>
                                    <Row className="mt-4">
                                        <Col md={6}>
                                            {chartData.length > 0 ? (
                                                <DonutChart
                                                    data={chartData}
                                                    centerText={{
                                                        label: "Assigned Students",
                                                        value: collegeStats?.totalStudentsCount || 0,
                                                    }}
                                                    height={350}
                                                    width={350}
                                                    showTooltip={true}
                                                    showLegend={true}
                                                    showCalloutLabels={true}
                                                />
                                            ) : (
                                                <NoDataView message="No verification data available for this college." />
                                            )}
                                        </Col>

                                        <Col md={6}>
                                            <Row className="g-2">
                                                <Col md={12}>
                                                    <StatsCard
                                                        title="Total Students"
                                                        value={collegeStats?.totalStudentsCount || 0}
                                                        icon={faClipboardCheck}
                                                        iconColor="primary"
                                                        valueColor="primary"
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <StatsCard
                                                        title="Verified Students"
                                                        value={collegeStats?.uniqueVerifications || 0}
                                                        icon={faCheckCircle}
                                                        iconColor="success"
                                                        valueColor="success"
                                                        onClick={() => setShowReverificationModal(selectedCollege)}
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <StatsCardWithProgress
                                                        title="Verification Rate"
                                                        value={`${(
                                                            ((collegeStats?.uniqueVerifications || 0) /
                                                                (collegeStats?.totalStudentsCount || 1)) *
                                                            100
                                                        ).toFixed(1)}%`}
                                                        progress={
                                                            ((collegeStats?.uniqueVerifications || 0) /
                                                                (collegeStats?.totalStudentsCount || 1)) *
                                                            100
                                                        }
                                                        icon={faUserCheck}
                                                        iconColor="success"
                                                        valueColor="success"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    {/* <Row className="mt-4 g-3"> */}
                                    {/* <Col md={6}>
                                            <StatsCard
                                                title="Total Verifications"
                                                value={collegeStats?.totalCount || 0}
                                                icon={faUniversity}
                                                iconColor="primary"
                                                valueColor="primary"
                                            />
                                        </Col> */}
                                    {/* <Col md={6}>
                                            <StatsCard
                                                title="Unique Verifications"
                                                value={collegeStats?.uniqueVerifications || 0}
                                                icon={faUsers}
                                                iconColor="warning"
                                                valueColor="warning"
                                            />
                                        </Col> */}
                                    {/* <Col md={6}>
                                            <StatsCard
                                                title="Total Operators"
                                                value={collegeStats?.totalOperators || 0}
                                                icon={faUserTie}
                                                iconColor="info"
                                                valueColor="info"
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <StatsCard
                                                title="Active Operators"
                                                value={collegeStats?.verificationStartedOperators || 0}
                                                icon={faPlay}
                                                iconColor="success"
                                                valueColor="success"
                                            />
                                        </Col> */}
                                    {/* </Row> */}
                                </>
                            ) : (
                                <NoDataView message="Please select a college to view statistics." />
                            )}
                        </Card.Body>
                    </Card>
                    {/* {selectedCollege && collegeStats && (
                        <Card className="shadow mt-4" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                            <Card.Body className="p-4">
                                <h5 className="text-secondary fw-bold mb-3" style={{ fontSize: '18px' }}>
                                    Operator Activity
                                </h5>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <StatsCard
                                            title="Total Operators"
                                            value={collegeStats?.totalOperators || 0}
                                            icon={faUserTie}
                                            iconColor="info"
                                            valueColor="info"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <StatsCard
                                            title="Active Operators"
                                            value={collegeStats?.verificationStartedOperators || 0}
                                            icon={faPlay}
                                            iconColor="success"
                                            valueColor="success"
                                        />
                                    </Col>
                                     <Col md={6}>
                                        <StatsCardWithProgress
                                            title="Operator Participation Rate"
                                            value={`${((collegeStats?.verificationStartedOperators || 0) / (collegeStats?.totalOperators || 1) * 100).toFixed(1)}%`}
                                            progress={(collegeStats?.verificationStartedOperators || 0) / (collegeStats?.totalOperators || 1) * 100}
                                            icon={faUserTie}
                                            iconColor="info"
                                            valueColor="info"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <StatsCard
                                            title="Inactive Operators"
                                            value={(collegeStats?.totalOperators || 0) - (collegeStats?.verificationStartedOperators || 0)}
                                            icon={faUserTie}
                                            iconColor="secondary"
                                            valueColor="secondary"
                                        />
                                    </Col> 
                                </Row>
                            </Card.Body>
                        </Card>
                    )} */}

                </>
            )
            }

            <ReverificationUsersModal
                show={showReverificationModal}
                handleClose={() => setShowReverificationModal(undefined)}
            />
        </>
    )
}

const NoDataView = ({ message }: { message: string }) => {
    return (
        <div className="text-center py-5">
            <div className="mb-3">
                <FontAwesomeIcon
                    icon={faUniversity}
                    className="text-muted"
                    style={{ fontSize: '48px', opacity: 0.3 }}
                />
            </div>
            <div className="text-muted" style={{ fontSize: '16px' }}>
                {message || "No college data available."}
            </div>
        </div>
    );
}